module.exports = __webpack_public_path__ + "static/img/PC-6.500c2e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/PC-6.png
// module id = HqMx
// module chunks = 0